<style scoped lang="scss">

</style>

<template>
    <div></div>
</template>

<script>
    export default {
        name: "PublicHero",
        data() {
            return {
                prequalification: {
                    "1": "1",
                    "2": "1",
                    "3": "1",
                    "4": "1",
                    "5": "1",
                    "6": "1",
                    "7": "1",
                    "8": "1",
                    "2.1": "1"
                }
            };
        },
        mounted() {

        }
    }
</script>
